'use client';

import { CommonButtonProps } from '../Button/Button.types';
import { useButton } from '../Button/useButton';
import { Link } from './Link';

type LinkProps = {
  label: string;
  href: string | null;
  openLinkInNewTab?: boolean;
  isDarkMode?: boolean;
  onClick?: (event?: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
  ariaLabel?: string;
  hasIcon?: boolean;
} & CommonButtonProps;

/**
 * Renders a next/link if internal link, anchor tag if external link
 */
export const LinkButton = ({
  href,
  openLinkInNewTab = true,
  style = 'link',
  hasArrow = false,
  size = 'small',
  className = '',
  isDarkMode = false,
  label,
  onClick = () => {},
  ariaLabel,
  hasIcon = false,
  ...props
}: LinkProps) => {
  const { buttonClassNames, buttonContent } = useButton({
    hasArrow,
    style,
    size,
    label,
    className,
    isDarkMode,
    hasIcon,
    openLinkInNewTab,
  });

  if (!href) {
    return null;
  }

  return (
    <Link
      href={href}
      target={openLinkInNewTab ? '_blank' : undefined}
      className={buttonClassNames}
      onClick={onClick}
      aria-label={ariaLabel ?? label}
      {...props}
    >
      {buttonContent}
    </Link>
  );
};
